import React from 'react';
import { MailIcon, PhoneIcon, MapPinIcon, ClockIcon } from 'lucide-react';
const LOGO_URL = 'https://cdn.magicpatterns.com/uploads/uTZG5K2BcyqsZi5cZa75st/Asset_21x.png';
export function LandingFooter() {
  return <footer className="w-full bg-white text-gray-700 py-14 px-5 border-t border-gray-100" data-id="element-319">
      <div className="max-w-4xl mx-auto" data-id="element-320">
        {/* Logo */}
        <div className="flex justify-center mb-8" data-id="element-321">
          <img src={LOGO_URL} alt="Brixen Credit" className="h-9 w-auto" data-id="element-322" />
        </div>

        {/* Contact */}
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 max-w-2xl mx-auto mb-10 text-sm" data-id="element-323">
          <a href="mailto:soporte@brixencredit.com" className="flex items-center justify-center sm:justify-start gap-2 hover:text-[#7B2FE0] transition-colors" data-id="element-324">
            <MailIcon className="w-4 h-4 text-[#7B2FE0]" data-id="element-325" />
            soporte@brixencredit.com
          </a>
          <a href="tel:+17863763985" className="flex items-center justify-center sm:justify-start gap-2 hover:text-[#7B2FE0] transition-colors" data-id="element-326">
            <PhoneIcon className="w-4 h-4 text-[#7B2FE0]" data-id="element-327" />
            (786) 376-3985
          </a>
          <div className="flex items-center justify-center sm:justify-start gap-2" data-id="element-328">
            <MapPinIcon className="w-4 h-4 text-[#7B2FE0]" data-id="element-329" />
            390 NE 191st St, Miami FL
          </div>
          <div className="flex items-center justify-center sm:justify-start gap-2" data-id="element-330">
            <ClockIcon className="w-4 h-4 text-[#7B2FE0]" data-id="element-331" />
            Lunes a Sábado, 9am – 9pm EST
          </div>
        </div>

        {/* Links */}
        <nav className="flex flex-wrap justify-center gap-x-6 gap-y-3 text-sm mb-10 font-medium text-gray-800" data-id="element-332">
          <a href="/terms" className="hover:text-[#7B2FE0] transition-colors" data-id="element-333">
            Terms &amp; Conditions
          </a>
          <a href="/privacy" className="hover:text-[#7B2FE0] transition-colors" data-id="element-334">
            Privacy Policy
          </a>
          <a href="/refund" className="hover:text-[#7B2FE0] transition-colors" data-id="element-335">
            Reembolso
          </a>
        </nav>

        {/* Legal disclaimers */}
        <div className="border-t border-gray-100 pt-8 space-y-4 text-xs text-gray-400 leading-relaxed max-w-3xl mx-auto text-center" data-id="element-336">
          <p data-id="element-337">Brixen Credit - Copyright © 2026. All Rights Reserved.</p>
          <p data-id="element-338">
            This website is not affiliated with, endorsed by, or sponsored by
            Facebook, Meta, or Google. All trademarks belong to their respective
            owners.
          </p>
          <p data-id="element-339">
            Brixen Credit LLC is a credit consulting and restoration service
            provider. We are not a credit bureau, law firm, or lender. We do not
            guarantee any specific results, score increases, removals, or
            approvals. Outcomes depend on third parties, including credit
            bureaus and creditors.
          </p>
          <p data-id="element-340">
            All services are performed in compliance with the Fair Credit
            Reporting Act (FCRA), the Credit Repair Organizations Act (CROA),
            and applicable federal and state laws. You have the right to dispute
            inaccurate information on your credit report yourself, free of
            charge.
          </p>
        </div>
      </div>
    </footer>;
}